import { createGlobalStyle } from 'styled-components';
import colors from './constants/colors';

const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
    min-height: 100%;
    box-sizing: border-box;
    font-size: 8px;
    line-height: 1.5;
  }

  * {
    box-sizing: inherit;
    background-repeat: no-repeat;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: 'LLCircularWeb', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
  }

  body {
    height: 100%;
    min-height: 100%;
    font: 2rem/1.5 LLCircularWeb, "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 300;
    -moz-osx-font-smoothing: grayscale;
    text-size-adjust: none;
    -webkit-font-smoothing: antialiased;
    color: ${colors.eerieBlack};
    margin: 0;
  }

  h1 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
  }

 h2 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    font-weight: normal;
    margin: 0;
  }

  p {
    font-size: 16px;
    font-weight: normal;
    margin: 0;
  }

  main {
    height: 100%;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default GlobalStyle;
